/**
 * The plans dialog (launch redesign 4a, 4 Nov 2026), opened from every Upgrade or See plans, whichever
 * screen it's on: one event, one dialog mounted at the app's root. `/settings/billing?plans=1` opens it too.
 */
export const OPEN_PLANS_EVENT = "lilia:open-plans";

export function openPlans() {
  if (typeof window !== "undefined") window.dispatchEvent(new CustomEvent(OPEN_PLANS_EVENT));
}

/** The plans people can buy: priced, in price order. Free leads; Beta and other unpriced plans aren't offered. */
export function offeredPlans<T extends { slug: string; monthlyPrice?: number | null }>(plans: T[]): { free?: T; paid: T[] } {
  return {
    free: plans.find((p) => p.slug === "free"),
    paid: plans.filter((p) => p.monthlyPrice != null && p.monthlyPrice > 0).sort((a, b) => a.monthlyPrice! - b.monthlyPrice!),
  };
}

/**
 * Ask Lilia's allowance as a multiple of Free's: never a credit count (rule 4 of the plan surfaces).
 * Null when either is unknown or unlimited.
 */
export function askMultiple(credits: number | undefined, freeCredits: number | undefined): number | null {
  if (!credits || !freeCredits || credits < 0 || freeCredits <= 0) return null;
  return Math.round(credits / freeCredits);
}
